function initCountdown(countdownElm) {
    const dateEndValue = countdownElm.dataset.datetime;
    if (typeof (dateEndValue) == 'undefined' || dateEndValue == null) return;

    let dateEnd = new Date(dateEndValue).getTime();

    setInterval(function () {
        let dateNow = new Date().getTime();
        let timeleft = dateEnd - dateNow;

        let daysLeft = Math.floor(timeleft / (1000 * 60 * 60 * 24));
        let hoursLeft = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minsLeft = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));

        let dayDisplay = countdownElm.querySelector('[data-unit="days"]');
        let hourDisplay = countdownElm.querySelector('[data-unit="hours"]');
        let minDisplay = countdownElm.querySelector('[data-unit="mins"]');

        let dayDisplayTime = dayDisplay.querySelector('.countdown__value');
        let hourDisplayTime = hourDisplay.querySelector('.countdown__value');
        let minDisplayTime = minDisplay.querySelector('.countdown__value');

        dayDisplayTime.textContent = daysLeft;
        hourDisplayTime.textContent = hoursLeft;
        minDisplayTime.textContent = minsLeft;

        if (timeleft < 0) {
            countdownElm.querySelector('.countdown__units').remove();
            countdownElm.querySelector('p').textContent = 'This Event Has Now Passed.';
        }
    }, 1000);
}

const countdownElms = document.querySelectorAll('.countdown--js');
countdownElms.forEach((countdownElm) => initCountdown(countdownElm));


const svg = document.getElementById("scene");

function attachLeader(tspan) {
    const svg = document.getElementById("scene");
    if (!svg) return;

    const leadersLayer = svg.querySelector("#leaders-layer");

    const symbolId = tspan.dataset.leader;
    if (!symbolId) return;

    let leader = svg.querySelector(`use[data-for="${symbolId}"]`);

    if (!leader) {
        leader = document.createElementNS("http://www.w3.org/2000/svg", "use");
        leader.setAttribute("href", `#${symbolId}`);
        leader.dataset.for = symbolId;
        leader.setAttribute("aria-hidden", "true");
        leadersLayer.appendChild(leader);
    }

    const start = tspan.getStartPositionOfChar(0);
    const end = tspan.getEndPositionOfChar(
        tspan.textContent.length - 1
    );

    const midX = (start.x + end.x) / 2;
    const midY = (start.y + end.y) / 2;

    const scale = Number(tspan.dataset.scale ?? 0.18);
    const offsetXFactor = Number(tspan.dataset.offsetX ?? 0);
    const offsetYFactor = Number(tspan.dataset.offsetY ?? -0.7);

    const bbox = leader.getBBox();

    const offsetX = bbox.width * scale * offsetXFactor;
    const offsetY = bbox.height * scale * offsetYFactor;

    leader.setAttribute(
        "transform",
        `
    translate(${midX + offsetX}, ${midY + offsetY})
    scale(${scale})
    translate(${-bbox.width / 2}, 0)
    `
    );
}

function trackAll() {
    svg.querySelectorAll("tspan[data-track][data-leader]").forEach(attachLeader);
}

window.addEventListener("load", trackAll);
window.addEventListener("resize", trackAll);